export const SETTINGS_TABS_LABEL = [
  "auto-apply",
  "profile",
  "email-and-notification",
  "account",
];
export const SETTINGS_TABS = {
  PROFILE: {
    name: "profile",
    label: "Profile",
    description:
      "Auto Update, Block Companies, Contact visibility, Profile visibility",
  },
  EMAIL_NOTIFICATION: {
    name: "email-and-notification",
    label: "Email & Notification",
    description: "Job Notification, Profile related notification, Whatsapp",
  },
  ACCOUNT: {
    name: "account",
    label: "Account",
    description: "Password, social accounts, deactivate",
  },
};
